module.exports = __webpack_public_path__ + "img/qrimg2.cbd85a4d.png";